import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Typography } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { firebaseAuth } from '@/core/providers/AuthFirebaseProvider';

const { Title, Text } = Typography;

export const ForgotPasswordForm: React.FC = () => {
  const [form] = Form.useForm<{ email: string }>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (values: { email: string }) => {
    try {
      setLoading(true);
      await firebaseAuth.sendPasswordResetEmail(values.email);
      message.success('If an account with this email exists, a password reset link has been sent.');
      navigate('/');
    } catch (error) {
      console.error('Password reset error:', error);
      message.error('Failed to send password reset email. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
      <Title level={2}>Forgotten password</Title>
      <Text type="secondary">
        Provide your email and we will send you a link to reset your password
      </Text>

      <Form
        form={form}
        name="forgot-password"
        onFinish={handleResetPassword}
        layout="vertical"
        size="large"
        style={{ marginTop: 32 }}
      >
        <Form.Item
          className="app-form-item"
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="Email" type="email" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Reset password
          </Button>
        </Form.Item>

        <Button type="link" onClick={() => navigate('/')}>
          Go back
        </Button>
      </Form>
    </div>
  );
};
